function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmateur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M287.635,250.097c-0.541-19.805,4.441-40.438,14.41-59.669 c10.157-19.593,25.307-37.283,43.815-51.152c18.508-13.868,39.738-23.443,61.396-27.689c21.256-4.166,42.459-3.155,61.314,2.926 c4.1,1.322,6.921,5.086,7.039,9.392c0.541,19.805-4.442,40.438-14.41,59.669c-3.304,6.375-7.135,12.545-11.44,18.45 c-8.928,12.247-19.888,23.345-32.375,32.702c-18.508,13.868-39.738,23.443-61.396,27.689c-21.256,4.166-42.459,3.155-61.314-2.926 C290.574,258.167,287.753,254.403,287.635,250.097z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M473.913,118.568c1.03,1.551,1.642,3.389,1.696,5.339c0.541,19.805-4.442,40.438-14.41,59.669 c-3.304,6.375-7.135,12.545-11.44,18.45c-8.928,12.247-19.888,23.345-32.375,32.702c-18.508,13.868-39.738,23.443-61.396,27.689 c-21.256,4.166-42.459,3.155-61.314-2.926c-1.93-0.622-3.57-1.79-4.784-3.295L473.913,118.568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#007871"
    },
    d: "M293.267,445.278c-10.629,0-19.247-8.617-19.247-19.247V37.243c0-10.629,8.617-19.247,19.247-19.247 s19.247,8.617,19.247,19.247v388.788C312.514,436.66,303.896,445.278,293.267,445.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M293.267,445.278c-10.629,0-19.247-8.617-19.247-19.247V37.243c0-10.629,8.617-19.247,19.247-19.247 V445.278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E56C1E"
    },
    d: "M432.563,491.076c-11.824-24.047-30.098-44.437-52.846-58.6 c-22.747-14.163-48.935-21.844-75.731-21.844h-20.055c-26.797,0-52.984,7.68-75.731,21.844 c-22.747,14.163-41.022,34.457-52.846,58.504c-2.247,4.568-1.976,9.861,0.715,14.182c2.691,4.322,7.422,6.837,12.513,6.837h250.754 c5.091,0,9.822-2.467,12.513-6.789C434.539,500.89,434.81,495.645,432.563,491.076z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2BA57"
    },
    d: "M293.644,410.633h-9.713c-26.797,0-52.984,7.68-75.731,21.844 c-22.747,14.163-41.022,34.457-52.846,58.504c-2.247,4.568-1.976,9.861,0.715,14.182S163.49,512,168.582,512h125.377 L293.644,410.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M293.59,349.827c0.74-27.097-6.077-55.327-19.715-81.639c-13.896-26.807-34.625-51.009-59.948-69.984 c-25.321-18.975-54.369-32.074-84.003-37.883c-29.082-5.701-58.091-4.316-83.89,4.003c-5.61,1.809-9.469,6.96-9.63,12.852 c-0.74,27.097,6.077,55.327,19.715,81.639c4.52,8.721,9.762,17.163,15.652,25.243c12.215,16.756,27.211,31.94,44.295,44.741 c25.321,18.975,54.37,32.074,84.003,37.883c29.082,5.701,58.091,4.316,83.89-4.003C289.57,360.87,293.429,355.719,293.59,349.827z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M38.726,169.871c-1.41,2.124-2.248,4.636-2.321,7.305c-0.74,27.097,6.077,55.327,19.715,81.639 c4.52,8.721,9.762,17.163,15.652,25.243c12.215,16.756,27.211,31.94,44.295,44.741c25.321,18.975,54.37,32.074,84.003,37.883 c29.082,5.701,58.091,4.316,83.89-4.003c2.639-0.851,4.884-2.448,6.545-4.508L38.726,169.871z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#489B6D"
    },
    d: "M290.839,141.031c0.541-19.805-4.441-40.438-14.41-59.669 c-10.157-19.593-25.307-37.283-43.815-51.152c-18.508-13.868-39.738-23.443-61.396-27.689c-21.256-4.166-42.459-3.155-61.314,2.926 c-4.101,1.322-6.921,5.086-7.039,9.392c-0.541,19.805,4.442,40.438,14.41,59.669c3.304,6.375,7.135,12.545,11.44,18.45 c8.928,12.247,19.888,23.345,32.375,32.702c18.508,13.868,39.738,23.443,61.396,27.689c21.256,4.166,42.459,3.155,61.314-2.926 C287.901,149.101,290.722,145.338,290.839,141.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A2CE86"
    },
    d: "M104.561,9.502c-1.03,1.551-1.642,3.389-1.696,5.339c-0.541,19.805,4.442,40.438,14.41,59.669 c3.304,6.375,7.135,12.545,11.44,18.45c8.928,12.247,19.888,23.345,32.375,32.702c18.508,13.868,39.738,23.443,61.396,27.689 c21.256,4.166,42.459,3.155,61.314-2.926c1.93-0.622,3.57-1.79,4.784-3.295L104.561,9.502z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmateur);
export default __webpack_public_path__ + "static/media/amateur.c292e25e63c32124d1774474f924d4d8.svg";
export { ForwardRef as ReactComponent };